/**
 * Constant representing the type of support case. Used for resource links.
 */
export const SUPPORT_CASE = 'Support Case';
